"use client";

import { useEffect, useRef, useState, type ReactNode } from "react";
import { ChevronDown } from "lucide-react";

interface Props {
  question: string;
  answer: string;
  /** Rendered under the answer (a link to the live data it points at). */
  extra?: ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

export default function AccordionItem({ question, answer, extra, isOpen, onToggle }: Props) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? contentRef.current.scrollHeight : 0);
    }
  }, [isOpen]);

  return (
    <div className="rounded-2xl bg-white border border-gray-200 overflow-hidden transition-shadow">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
      >
        <span className="text-sm sm:text-base font-semibold text-gray-900">{question}</span>
        <ChevronDown
          className={`w-5 h-5 text-gray-400 shrink-0 transition-transform duration-300 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>
      <div
        style={{ height }}
        className="transition-[height] duration-300 ease-in-out overflow-hidden"
      >
        <div ref={contentRef} className="px-5 pb-4 text-sm text-gray-600 leading-relaxed">
          {answer}
          {extra ? <div className="mt-2">{extra}</div> : null}
        </div>
      </div>
    </div>
  );
}
